import script from "./BlockTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlockTitle.vue?vue&type=script&setup=true&lang=ts"

import "./BlockTitle.vue?vue&type=style&index=0&id=30291558&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30291558"]])

export default __exports__